<template>
    <div class="flex justify-center items-center min-h-screen bg-gray-900">
        <div class="text-center w-96">
            <div class="mb-6 w-10/12 mx-auto">
                <img src="@/assets/Clubs Casino_Poker Blue_Snow White.svg" alt="Clubs Casino Logo" class="w-full" />
            </div>
            <div v-if="showLogin">
                <LoginForm :apiUrl="apiUrl" @new-password-required="handleNewPasswordRequired" @set-tokens="setTokens"/>
            </div>
            <div v-else>
                <PasswordResetForm :apiUrl="apiUrl" :sessionToken="sessionToken" :email="email" @set-tokens="setTokens"/>
            </div>
        </div>
    </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';
import PasswordResetForm from '@/components/PasswordResetForm.vue';

export default {
    components: {
        LoginForm,
        PasswordResetForm
    },
    data() {
        return {
            apiUrl: process.env.VUE_APP_API_GATEWAY_URL,
            email: '',
            showLogin: true,
            sessionToken: null
        };
    },
    methods: {
        handleNewPasswordRequired(sessionToken, email) {
            this.showLogin = false;
            this.sessionToken = sessionToken;
            this.email = email;
        },
        async setTokens(accessToken, idToken, refreshToken) {
            this.$store.commit('setRefreshToken', refreshToken);
            this.$store.commit('setAccessToken', accessToken);
            this.$store.commit('setIdToken', idToken);
            this.$router.push({ name: 'DashboardView' });
        }
    }
};
</script>
